export const OPEN_CHECKLIST_QUERY_PARAM = 'openChecklist';

export const SKIP_SURVEY_PENDING_OPEN_CHECKLIST_KEY = 'skipSurveyPendingOpenChecklist';

export const MODAL_LEARN_ABOUT_PLAN = 'learn-about-plan';

export const APP_DOWNLOAD_URL = 'https://udemy.app.link/garBkjjtDO';

/** Hide PP checklist after this long from `currentSubscriptionEnrollment.startDate` (when start is known). */
export const CHECKLIST_SUBSCRIPTION_VISIBILITY_WINDOW_MS = 14 * 24 * 60 * 60 * 1000;

/** Video lectures counted toward the "watch lessons" checklist step. */
export const PP_CHECKLIST_WATCH_LESSONS_TOTAL = 5;
